<template>
  <div class="container">
    <sys-dialog
      v-show="dialogVisible"
      :bgi="dialogBgi"
      :show-close="true"
      :error-msg="errorMsg"
      @close="closeDialog"
    />

    <sys-dialog
      v-show="renderDialogVisible"
      :show-close="false"
      :hasNoMaxWidth="true"
      @close="closeDialog"
    >
      <img style="width: 355px;" :src="dialogImg" alt="success"/>
    </sys-dialog>

<!--    <sys-dialog-->
<!--      v-show="dialogLoginVisible"-->
<!--      :show-close="false"-->
<!--      :hasNoMaxWidth="true"-->
<!--      :zIndex="2"-->
<!--      @close="closeDialogLogin"-->
<!--    >-->
<!--      <div :class="isMobile ? 'form-container isMobile' : 'form-container'">-->
<!--&lt;!&ndash;        <img&ndash;&gt;-->
<!--&lt;!&ndash;          class="form-close-img"&ndash;&gt;-->
<!--&lt;!&ndash;          src="../assets/sport5/close-dialog.png"&ndash;&gt;-->
<!--&lt;!&ndash;          @click="closeDialogLogin"&ndash;&gt;-->
<!--&lt;!&ndash;        />&ndash;&gt;-->

<!--        <div :class="isRegisterAction ? 'form' : 'form login'">-->
<!--          <div class="tags">-->
<!--            <span-->
<!--              :class="isRegisterAction ? 'tag register active' : 'tag register'"-->
<!--              @click="-->
<!--                () => {-->
<!--                  switchTab(true);-->
<!--                }-->
<!--              "-->
<!--            ></span>-->
<!--            <span-->
<!--              :class="!isRegisterAction ? 'tag active' : 'tag'"-->
<!--              @click="-->
<!--                () => {-->
<!--                  switchTab(false);-->
<!--                }-->
<!--              "-->
<!--            ></span>-->
<!--          </div>-->

<!--          <div class="inputs">-->
<!--            <div class="form-input">-->
<!--              <img src="../assets/sport4/icon-username.png" />-->
<!--              <input-->
<!--                v-model="form.username"-->
<!--                placeholder="Tên đăng nhập"-->
<!--                maxlength="20"-->
<!--                autocomplete="off"-->
<!--                @blur="() => onBlur('username')"-->
<!--                @change="() => onKeyup('username')"-->
<!--                @keyup="() => onKeyup('username')"-->
<!--              />-->
<!--              <span class="errMsg">{{ formErrMsg.username }}</span>-->
<!--            </div>-->

<!--            <div-->
<!--              class="form-input"-->
<!--              :style="!isRegisterAction ? { marginBottom: 0 } : ''"-->
<!--            >-->
<!--              <img src="../assets/sport4/icon-password.png" />-->
<!--              <input-->
<!--                v-model="form.password"-->
<!--                type="password"-->
<!--                minlength="4"-->
<!--                maxlength="15"-->
<!--                autocomplete="new-password"-->
<!--                placeholder="Mật khẩu"-->
<!--                @blur="() => onBlur('password')"-->
<!--              />-->
<!--              <span class="errMsg">{{ formErrMsg.password }}</span>-->
<!--              <a-->
<!--                v-if="!isRegisterAction"-->
<!--                class="error"-->
<!--                href="https://www.2q.com"-->
<!--                >Quên Mật Khẩu?</a-->
<!--              >-->
<!--            </div>-->

<!--            <div class="form-input" v-show="isRegisterAction">-->
<!--              <img src="../assets/sport4/icon-phone.png" />-->
<!--              <input-->
<!--                v-model="form.phone"-->
<!--                placeholder="Số điện thoại"-->
<!--                maxlength="11"-->
<!--                oninput="value=value.replace(/^\D/, '')"-->
<!--                @blur="() => onBlur('phone')"-->
<!--              />-->
<!--              <span class="errMsg">{{ formErrMsg.phone }}</span>-->
<!--            </div>-->

<!--            <div-->
<!--              class="form-input"-->
<!--              v-show="isRegisterAction"-->
<!--              style="margin-bottom: 0;"-->
<!--            >-->
<!--              <img src="../assets/sport4/icon-email.png" />-->
<!--              <input-->
<!--                v-model="form.email"-->
<!--                autocomplete="off"-->
<!--                placeholder="Email"-->
<!--                @blur="() => onBlur('email')"-->
<!--              />-->
<!--              <span-->
<!--                :class="-->
<!--                  formErrMsg.email && formErrMsg.email.length > 20-->
<!--                    ? 'errMsg longErrMsg'-->
<!--                    : 'errMsg'-->
<!--                "-->
<!--                >{{ formErrMsg.email }}</span-->
<!--              >-->
<!--            </div>-->

<!--            <v-captcha-->
<!--              ref="vcaptcha1"-->
<!--              :dialogVisible="dialogVisible"-->
<!--              :showCheck="showCheck"-->
<!--              @cb="handleConfirm"-->
<!--              :vstyle="-->
<!--                isMobile-->
<!--                  ? {-->
<!--                      width: '50%',-->
<!--                      height: '18%',-->
<!--                      position: 'absolute',-->
<!--                      left: '25%',-->
<!--                      bottom: '-6%'-->
<!--                    }-->
<!--                  : {-->
<!--                      width: '50%',-->
<!--                      height: '18%',-->
<!--                      position: 'absolute',-->
<!--                      left: '25%',-->
<!--                      bottom: 0-->
<!--                    }-->
<!--              "-->
<!--              :nativeButton="-->
<!--                isMobile-->
<!--                  ? {-->
<!--                      width: '100%',-->
<!--                      height: '47px'-->
<!--                    }-->
<!--                  : {-->
<!--                      width: '100%',-->
<!--                      height: '65px'-->
<!--                    }-->
<!--              "-->
<!--            >-->
<!--              <div-->
<!--                v-show="isRegisterAction"-->
<!--                class="submitBtn reg"-->
<!--                :style="-->
<!--                  `background-image: url(${require('../assets/sport5/btn-register.png')});background-size: 100% 100%;`-->
<!--                "-->
<!--                @click="submitAction(1)"-->
<!--              ></div>-->
<!--            </v-captcha>-->

<!--            <div-->
<!--              v-show="!isRegisterAction"-->
<!--              class="submitBtn login"-->
<!--              :style="-->
<!--                `background-image: url(${require('../assets/sport5/btn-login.png')});background-size: 100% 100%;`-->
<!--              "-->
<!--              @click="submitAction(2)"-->
<!--            ></div>-->

<!--            <div class="bottom-tips" v-if="isRegisterAction">-->
<!--              <span>Bạn đã có tài khoản ?</span>-->
<!--              <span style="color: #DAFC0A">Đăng nhập ngay</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </sys-dialog>-->

    <sys-loading :loading="loading" />

    <div v-if="isMobile" class="mobileRoot">
      <div class="mobileMain">
        <div class="custom">
          <a href="https://m.me/888BVN" target="_blank">
            <img src="../assets/sport6/facebook.png" alt="facebook"/>
          </a>
          <a href="https://t.me/nhacai888b" target="_blank">
            <img src="../assets/sport6/telegram.png" alt="telegram"/>
          </a>
        </div>
        <img class="logo" src="../assets/sport6/logo.png" alt="logo"/>
        <img class="title" src="../assets/sport6/title.png" alt="title"/>

        <div class="app-middle-slider">
          <sys-swiper :swiper-images="swiperImagesLeft" />
        </div>

        <div class="app-middle-content-6">
          <div class="form">
            <div class="tags">
              <span :class="isRegisterAction ? 'tag register active' : 'tag register'" @click="() => {switchTab(true);}"/>
              <span :class="!isRegisterAction ? 'tag active' : 'tag'" @click="() => {switchTab(false);}"/>
            </div>

            <div :class="['app-inputs-6', {'loginInputs' : !isRegisterAction}]">
              <div class="app-form-input">
                <div class="inputArea">
                  <img class="icon" src="../assets/sport4/icon-username.png" alt="name"/>
                  <input
                    v-model="form.username"
                    placeholder="Tên đăng nhập"
                    maxlength="20"
                    autocomplete="off"
                    @blur="() => onBlur('username')"
                    @change="() => onKeyup('username')"
                    @keyup="() => onKeyup('username')"
                  />
                </div>
                <span class="errMsg">{{ formErrMsg.username }}</span>
              </div>

              <div class="app-form-input" :style="!isRegisterAction ? { marginBottom: 0 } : ''">
                <div class="inputArea">
                  <img class="icon" src="../assets/sport6/form/lock.png" alt="lock"/>
                  <input
                    v-model="form.password"
                    type="password"
                    minlength="4"
                    maxlength="15"
                    autocomplete="new-password"
                    placeholder="Mật khẩu"
                    @blur="() => onBlur('password')"
                  />
                </div>
                <span class="errMsg">{{ formErrMsg.password }}</span>
                <a v-if="!isRegisterAction" class="error" href="https://www.2q.com">Quên Mật Khẩu?</a>
              </div>

              <div class="app-form-input" v-show="isRegisterAction">
                <div class="inputArea">
                  <img class="icon" src="../assets/sport6/form/check.png" alt="check"/>
                  <input
                    v-model="form.rePassword"
                    type="password"
                    placeholder="Nhập lại mật khẩu"
                    minlength="4"
                    maxlength="15"
                    autocomplete="new-password"
                    @blur="() => onBlur('repassword')"
                  />
                </div>
                <span class="errMsg">{{ formErrMsg.rePassword }}</span>
              </div>

              <div class="app-form-code-input" v-show="isRegisterAction" style="margin-bottom: 0;">
                <div class="codeArea">
                  <div class="codeInput">
                    <img class="icon" src="../assets/sport6/form/safe.png" alt="safe"/>
                    <input
                      v-model="form.verificationCode"
                      maxlength="4"
                      oninput="value=value.replace(/[\W]/g, '')"
                      placeholder="Mã xác minh"
                      @blur="() => onBlur('code')"
                    />
                  </div>
                  <span class="code">
                    <img @click="getCode" :src="captchaImg" alt="captcha">
                  </span>
                </div>

                <span class="errMsg">
                  {{ formErrMsg.code }}
                </span>
              </div>

              <div v-if="isRegisterAction" class="submitArea" @click="submitAction(1)">
                <img class="btn" src="../assets/sport6/regist.gif" alt="regist">
              </div>
              <div v-else class="submitArea login" @click="submitAction(2)">
                <img class="btn" src="../assets/sport6/login.gif" alt="login">
              </div>
            </div>
          </div>
        </div>

        <div class="app-bottom-banner">
          <img src="../assets/sport6/icon.png" alt="icon">
          <img src="../assets/sport6/icon-3.png" alt="icon">
          <img src="../assets/sport6/icon-1.png" alt="icon">
          <img src="../assets/sport6/icon-2.png" alt="icon">
        </div>
      </div>
    </div>
    <div v-else class="content">
      <div class="custom">
        <a href="https://m.me/888BVN" target="_blank">
          <img src="../assets/sport6/facebook.png" alt="facebook"/>
        </a>
        <a href="https://t.me/nhacai888b" target="_blank">
          <img src="../assets/sport6/telegram.png" alt="telegram"/>
        </a>
      </div>
      <div class="main">
        <div class="main-left">
          <img class="logo" src="../assets/sport6/logo.png" alt="logo"/>
          <div class="main-left-slider">
            <sys-swiper :swiper-images="swiperImagesLeft" />
          </div>
          <div class="bottom-banner">
            <img src="../assets/sport6/icon.png" alt="icon">
            <img src="../assets/sport6/icon-3.png" alt="icon">
            <img src="../assets/sport6/icon-1.png" alt="icon">
            <img src="../assets/sport6/icon-2.png" alt="icon">
          </div>
        </div>
        <div class="main-right">
          <img class="title" src="../assets/sport6/title.png" alt="title"/>
          <div class="form-container">
            <div :class="isRegisterAction ? 'form' : 'form login'">
              <div class="tags">
                <span :class="isRegisterAction ? 'tag register active' : 'tag register'" @click="() => {switchTab(true);}"/>
                <span :class="!isRegisterAction ? 'tag active' : 'tag'" @click="() => {switchTab(false);}"/>
              </div>

              <div :class="['inputs', {'loginInputs' : !isRegisterAction}]">
                <div class="form-input">
                  <img src="../assets/sport4/icon-username.png" alt="name"/>
                  <input
                    v-model="form.username"
                    placeholder="Tên đăng nhập"
                    maxlength="20"
                    autocomplete="off"
                    @blur="() => onBlur('username')"
                    @change="() => onKeyup('username')"
                    @keyup="() => onKeyup('username')"
                  />
                  <span class="errMsg">{{ formErrMsg.username }}</span>
                </div>

                <div
                  class="form-input"
                  :style="!isRegisterAction ? { marginBottom: 0 } : ''"
                >
                  <img src="../assets/sport6/form/lock.png" alt="lock"/>
                  <input
                    v-model="form.password"
                    type="password"
                    minlength="4"
                    maxlength="15"
                    autocomplete="new-password"
                    placeholder="Mật khẩu"
                    @blur="() => onBlur('password')"
                  />
                  <span class="errMsg">{{ formErrMsg.password }}</span>
                  <a
                    v-if="!isRegisterAction"
                    class="error"
                    href="https://www.2q.com"
                  >Quên Mật Khẩu?</a
                  >
                </div>

                <div class="form-input" v-show="isRegisterAction">
                  <img src="../assets/sport6/form/check.png" alt="check"/>
                  <input
                    v-model="form.rePassword"
                    type="password"
                    placeholder="Nhập lại mật khẩu"
                    minlength="4"
                    maxlength="15"
                    @blur="() => onBlur('repassword')"
                  />
                  <span class="errMsg">{{ formErrMsg.rePassword }}</span>
                </div>

                <div
                  class="form-input"
                  v-show="isRegisterAction"
                  style="margin-bottom: 0;"
                >
                  <div class="codeArea">
                    <img src="../assets/sport6/form/safe.png" alt="safe"/>
                    <input
                      v-model="form.verificationCode"
                      oninput="value=value.replace(/[\W]/g, '')"
                      placeholder="Mã xác minh"
                      @blur="() => onBlur('code')"
                    />
                    <span class="code">
                      <img class="codeImg" v-show="captchaImg" :src="captchaImg" @click="getCode" alt="code">
                    </span>
                  </div>
                  <span class="errMsg">{{ formErrMsg.code }}</span>
                </div>

                <div v-if="isRegisterAction" class="submitArea">
                  <img class="btn" src="../assets/sport6/regist.gif" @click="submitAction(1)" alt="regist">
                </div>
                <div v-else class="submitArea login">
                  <img class="btn" src="../assets/sport6/login.gif" @click="submitAction(2)" alt="login">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import {swiper, swiperSlide} from "vue-awesome-swiper";
import '../../static/js/initRem'

import {DOMAIN_INVITE_CODE, FORM_VALID_MESSAGE} from "../utils/constant";
import {createCustomer, getCapCode, userLogin, userRegister} from "../utils/request";
import {encodePlatformUrl, isMobile, replacePhonePrefix, validForm} from "../utils/tools";
import {captcha} from "@/mixins/captcha";

const check = {
  //邮箱
  email: /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/,
  // 用户名
  username: /^[0-9a-zA-Z]{4,20}$/,
  // 用户密码
  password: /^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/
};

export default {
  name: "Sport",
  mixins: [captcha],
  components: { swiper, swiperSlide },
  data() {
    return {
      renderDialogVisible: false,
      dialogLoginVisible: false,
      isMobile: isMobile(),
      swiperMobileVisible: false,
      isRegisterAction: true,
      dialogVisible: false,
      loading: false,

      dialogImg: require("../assets/sport6/success.png"),
      dialogBgiRegister: require("../assets/sport5/register-success-new.png"),
      dialogBgiLogin: require("../assets/sport6/success.png"),
      dialogBgi: require("../assets/sport4/bgi-dialog.png"),

      form: {
        by: 1,
        username: "",
        password: "",
        rePassword: "",
        code: "",
        link: "",
        domain: "",
        inviteCode: null,
        verificationCode:''
      },
      formErrMsg: {
        username: null,
        password: null,
        rePassword: null,
        code: null
      },
      errorMsg: {
        title: "",
        content: ""
      },
      closeImage: require("../assets/sport5/close-dialog.png"),

      swiperImagesLeft: [
        require("../assets/sport6/game.png"),
        require("../assets/sport6/game-1.png"),
        require("../assets/sport6/game-2.png"),
        require("../assets/sport6/game-3.png"),
        require("../assets/sport6/game-4.png"),
      ],
      captchaImg: ''
    };
  },
  mounted() {
    this.swiperMobileVisible = isMobile() && window.innerWidth > 360;
    window.onresize = () => {
      this.isMobile = isMobile();
      this.swiperMobileVisible = this.isMobile && window.innerWidth > 360;
    };
    this.getCode()
  },
  methods: {
    getCode() {
      getCapCode().then(res=>{
        if (!res.body.code){
          this.captchaImg = res.body.data
        }
      })
        .catch(err=>{
          console.log(err)
        })
    },
    onKeyup(key) {
      if(key === 'username') {
        this.form.username = this.form.username.replace(/[\W]/g,'')
      }
    },
    switchTab(flag) {
      this.errMsg = {
        username: null,
        password: null,
        phone: null,
        email: null
      };
      this.isRegisterAction = flag;
    },
    onBlur(key) {
      if (key === "username") {
        this.form.username = this.form.username.replace(/[\W]/g,'')
        if (!this.form.username) {
          this.formErrMsg.username = "*Vui lòng nhập tên đăng nhập";
        } else if (!check.username.test(this.form.username)) {
          this.formErrMsg.username = "*Tên đăng nhập phải từ 4 -20 ký tự";
        } else {
          this.formErrMsg.username = null;
        }
      }

      if (key === "password") {
        if (!this.form.password) {
          this.formErrMsg.password = "*Vui lòng nhập mật khẩu";
        } else if (this.form.rePassword.length < 6) {
          this.formErrMsg.rePassword = "Mật khẩu không trùng khớp"
        } else if (!check.password.test(this.form.password)) {
          this.formErrMsg.password = "*Mật khẩu phải từ 6 đến 15 ký tự";
        } else {
          this.formErrMsg.password = null;
        }
      }

      if (key === "repassword") {
        if (!this.form.rePassword) {
          this.formErrMsg.rePassword = "* Vui lòng nhập lại mật khẩu";
        } else if (this.form.rePassword.length < 6) {
          this.formErrMsg.rePassword = "Mật khẩu không trùng khớp"
        } else if (!check.password.test(this.form.rePassword)) {
          this.formErrMsg.rePassword = "*Số điện thoại không đúng định dạng";
        } else if (this.form.rePassword !== this.form.password){
          this.formErrMsg.rePassword = "*Mật khẩu không trùng khớp"
        } else{
          this.formErrMsg.rePassword = null;
        }
      }

      if (key === "code") {
        if (!this.form.verificationCode) {
          this.formErrMsg.code = "* Vui lòng nhập mã xác minh";
        } else {
          this.formErrMsg.code = null;
        }
      }
    },
    closeDialogLogin() {
      this.dialogLoginVisible = false;
    },
    showDialogLogin() {
      this.dialogLoginVisible = true;
    },
    submitAction(type) {
      let errorMsg = validForm(type, this.form);

      if (type === 1) {
        //  注册校验
        // 用户名
        if (!this.form.username) {
          this.formErrMsg.username = "*Vui lòng nhập tên đăng nhập";
          return;
        } else if (!check.username.test(this.form.username)) {
          this.formErrMsg.username = "*Tên đăng nhập phải từ 4 -20 ký tự";
          return;
        }
        // 密码
        if (!this.form.password) {
          this.formErrMsg.password = "*Vui lòng nhập mật khẩu";
          return;
        } else if (!check.password.test(this.form.password)) {
          this.formErrMsg.password = "*Mật khẩu phải từ 6 đến 15 ký tự";
          return;
        }
        // 重复密码
        if (!this.form.rePassword) {
          this.formErrMsg.rePassword = "*Vui lòng nhập số điện thoại";
          return;
        } else if (!check.password.test(this.form.password)) {
          this.formErrMsg.rePassword = "*Mật khẩu phải từ 6 đến 15 ký tự";
          return;
        } else if (this.form.password !== this.form.rePassword) {
          this.formErrMsg.rePassword = '*Mật khẩu không trùng khớp'
          return;
        }
        // 验证码
        if (!this.form.verificationCode) {
          this.formErrMsg.code = "*Vui lòng nhập mã xác minh";
          return;
        } else {
          this.formErrMsg.code = null;
        }
      } else if (type === 2) {
        // 登陆校验
        // 用户名
        if (!this.form.username) {
          this.formErrMsg.username = "*Vui lòng nhập tên đăng nhập";
          return;
        } else if (!check.username.test(this.form.username)) {
          this.formErrMsg.username = "*Tên đăng nhập phải từ 4 -20 ký tự";
          return;
        }
        // 密码
        if (!this.form.password) {
          this.formErrMsg.password = "*Vui lòng nhập mật khẩu";
          return;
        } else if (!check.password.test(this.form.password)) {
          this.formErrMsg.password = "*Mật khẩu phải từ 6 đến 15 ký tự";
          return;
        }
      }

      this.loading = true;
      // 登陆
      if (type === 2) {
        let temp = Object.assign({}, this.form);
        let params = {
          acctType: 6,
          by: 1,
          email: temp.email,
          userName: temp.username,
          password: md5(temp.password)
        };
        this.login(params);
      } else {
        // this.form.inviteCode = DOMAIN_INVITE_CODE[location.host] || Vue.prototype.inviteCode;
        this.form.inviteCode = this.inviteCodeObj[location.host] || DOMAIN_INVITE_CODE[location.host] || "";
        this.form.domain = location.host;
        this.form.userName = this.form.username;
        this.register();
      }
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.dialogLoginVisible = false;
            this.renderDialogVisible = true;
            this.dialogImg = this.dialogBgiLogin;
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password,
                res.data.data.token
              );
            }, 5000);
          } else {
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      this.params = Object.assign({}, this.form);
      // let params = (this.params = Object.assign({}, this.form));
      // if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
      //   this.setDialogMsg(
      //     FORM_VALID_MESSAGE.registerFailTitle,
      //     FORM_VALID_MESSAGE.passwordMsg
      //   );
      //   this.loading = false;
      //   return;
      // }
      // this.handleCheck();

      this.handleConfirm()
    },
    handleConfirm(params = Object.assign({}, this.form)) {
      // params.phone = params.phone.length === 10 ? params.phone : replacePhonePrefix(params.phone);
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      userRegister(params)
        .then(res => {
          if (res.data.code == 0) {
            this.dialogLoginVisible = false;
            this.renderDialogVisible = true;
            this.dialogImg = this.dialogBgiRegister;
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
            this.handleOpen(res.data.code);
          }
          this.loading = false;
          this.getCode()
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
          this.getCode()
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
::-webkit-input-placeholder {
  color: #ffffff;
}

// 通用文件
.content,
.mobileRoot {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}

// 电脑端
.content {
  background-image: url("../assets/sport6/bg.jpg");
  background-size: 100% 100%;

  .custom{
    position: absolute;
    top: 28px;
    right: 55px;
    display: flex;
    align-items: center;
    column-gap: 25px;
    z-index: 100;
  }

  .main {
    width: 100%;
    display: flex;
    align-items: stretch;
    justify-content: space-evenly;
    box-sizing: border-box;
    position: relative;

    .main-left {
      display: flex;
      align-items: center;
      flex-direction: column;
      position: relative;
      padding-left: 172px;
      flex: 2;
      .logo{
        position: absolute;
        left: 30px;
        z-index: 10;
      }
      .main-left-slider{
        margin-top: 20px;
        width: 540px;
        height: 680px;
        overflow: hidden;
        img{
          width: 544px;
        }
      }
      .bottom-banner {
        display: flex;
        height: 225px;
        img {
          height: 225px;
        }
      }
    }
    .main-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      position: relative;
      top: 106px;
      right: 106px;
      .title {
        margin-bottom: 18px;
      }
    }


    .social-app {
      position: absolute;
      left: 24px;
      top: 20px;
      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
        cursor: pointer;
      }
    }

    .top-banner {
      display: flex;
      align-items: center;
      img {
        height: 135px;
      }
    }

    .middle-content {
      width: 100%;
      height: 500px;
      display: flex;
      align-items: center;
      cursor: pointer;
      .middle-content-left {
        flex: 2;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .middle-content-center {
        flex: 3;
        display: flex;
        align-items: center;
        flex-direction: column;
        .giai-tri {
          height: 332px;
        }
        .dang-ky-nhan {
          width: 325px;
          height: 75px;
          margin-top: 20px;
        }
      }
      .middle-content-right {
        flex: 2;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

// 手机端
.mobileRoot {
  height: auto;
  min-height: 100vh;
  background-image: url("../assets/sport6/bg-h5.jpg");
  background-size: cover;
  padding-bottom: 5vh;

  .mobileMain {
    display: flex;
    flex-flow: column;
    align-items: center;
    position: relative;

    .logo {
      position: absolute;
      width: 2.21rem;
      height: 1.62rem;
      left: 0.15rem;
      z-index: 10;
    }

    .custom{
      position: absolute;
      top: 0.28rem;
      right: 0.31rem;
      display: flex;
      align-items: center;
      column-gap: 0.23rem;
      z-index: 100;
      a{
        display: flex;
        img{
          width: 0.65rem;
          height: 0.65rem;
        }
      }
    }


    .title {
      margin-top: 1.31rem;
      width: 5.53rem;
      height: 1.4rem;
    }

    .app-middle-slider {
      width: 4.2rem;
      height: 5.29rem;
      img{
        width: 4.2rem;
        height: 5.29rem;
      }
    }
    .app-middle-content-6 {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 0.5rem;
      .form {
        width: 7.18rem;
        height: 8rem;
        background-image: url("../assets/sport6/form/form-bg.png");
        background-size: 100% 100%;

        .tags {
          width: 100%;
          position: relative;
          top: -0.35rem;
          display: flex;
          align-items: center;
          justify-content: center;

          .tag {
            width: 3.19rem;
            height: 0.94rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background-image: url("../assets/sport6/form/login-1.png");
            background-size: 100% 100%;
            cursor: pointer;
            position: relative;

            &.register {
              background-image: url("../assets/sport6/form/register-1.png");
            }

            &.active {
              width: 3.84rem;
              height: 1.11rem;
              background-image: url("../assets/sport6/form/login-2.png");
              &.register {
                background-image: url("../assets/sport6/form/register-2.png");
              }
            }
          }
        }

        .app-inputs-6 {
          position: relative;
          top: -0.3rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          row-gap: 0.43rem;
          .bottom-tips {
            font-size: 0.18rem;
            line-height: 0.4rem;
            font-weight: 400;
            color: #000000;
            //display: none;
          }
        }
        .loginInputs{
          top: 0;
        }

        .app-form-input {
          width: 5.18rem;
          height: 0.7rem;
          background: transparent url("../assets/sport5/bgi-input.png") no-repeat;
          background-size: 100% 100%;
          position: relative;
          display: flex;
          flex-direction: column;
          .inputArea {
            display: flex;
            align-items: center;
            height: 100%;
            padding: 0 0.1rem;
            img {
              width: 0.21rem;
              height: 0.21rem;
              margin: 0 0.07rem 0 0.2rem;
            }
            input {
              flex: 1;
              height: 100%;
              border: none;
              outline: none;
              font-size: 0.24rem;
              color: #ffffff;
              background-color: transparent;
              &::placeholder {
                color: #fbfde8;
                opacity: 0.9;
                font-size: 0.2rem;
                // 这里让浏览器自动去判断
                line-height: normal;
              }
            }
          }
          .errMsg {
            position: absolute;
            top: 0.7rem;
            background: linear-gradient(135.48deg, #990000 0%, #F90707 89.26%);
            -webkit-background-clip: text;
            color: transparent;
            font-size: 0.18rem;
            line-height: 0.3rem;
            font-weight: 400;

            &.longErrMsg {
              left: 50%;
              width: 100%;
              transform: translateX(-50%);
            }
          }
        }
        .app-form-code-input {
          width: 5.18rem;
          height: 0.7rem;
          position: relative;
          display: flex;
          flex-direction: column;
          .codeArea {
            display: flex;
            align-items: center;
            height: 100%;
            .codeInput {
              height: 100%;
              width: 3.5rem;
              display: flex;
              align-items: center;
              background: transparent url("../assets/sport5/bgi-input.png") no-repeat;
              background-size: 100% 100%;
              img {
                width: 0.21rem;
                height: 0.21rem;
                margin: 0 0.07rem 0 0.2rem;
              }
              input {
                flex: 1;
                height: 100%;
                border: none;
                outline: none;
                font-size: 0.24rem;
                color: #ffffff;
                background-color: transparent;
                &::placeholder {
                  color: #fbfde8;
                  opacity: 0.9;
                  font-size: 0.2rem;
                  // 这里让浏览器自动去判断
                  line-height: normal;
                }
              }
            }
            .code {
              width: 1.5rem;
              height: 0.55rem;
              position: relative;
              img {
                position: absolute;
                width: 100%;
                height: 100%;
                border-radius: 0.1rem;
                margin-left: 0.1rem;
              }
            }
          }
          .errMsg {
            position: absolute;
            top: 0.7rem;
            background: linear-gradient(135.48deg, #990000 0%, #F90707 89.26%);
            -webkit-background-clip: text;
            color: transparent;
            font-size: 0.18rem;
            line-height: 0.3rem;
            font-weight: 400;

            &.longErrMsg {
              left: 50%;
              width: 100%;
              transform: translateX(-50%);
            }
          }
        }

        .submitArea {
          text-align: center;
          .btn{
            cursor: pointer;
            width: 60%;
          }
        }
        .login{
          margin-top: 0.3rem;
        }

        a.error {
          position: absolute;
          top: 0.7rem;
          right: 0;
          color: #000;
          font-size: 0.18rem;
          line-height: 0.4rem;
          font-weight: 400;
          text-decoration: underline;
          text-align: center;
        }
        .submitBtn {
          margin-top: 0.2rem;
          width: 1.8rem;
          cursor: pointer;
          &.reg {
            height: 0.55rem;
          }

          &.login {
            margin: 0.2rem auto;
            height: 0.55rem;
            bottom: 0.42rem;
          }
        }
      }
    }
    .app-bottom-banner {
      margin-top: 0.3rem;
      display: flex;
      justify-content: center;
      img {
        width: 1.85rem;
      }
    }

    .top-banner {
      display: flex;
      align-items: center;
      img {
        height: 93px;
      }
    }
  }
}

/deep/ .close-img {
  width: 40px;
  height: 40px;
  opacity: 0;
  top: 40px !important;
  right: 50px !important;
}

@media only screen and (max-width: 767px) {
  /deep/ .moda {
    padding: 20vw !important;
  }

  /deep/ .close-img {
    width: 30px !important;
    height: 30px !important;
    opacity: 0;
    top: 10px !important;
    right: 15px !important;
  }
}

// 注册弹窗
@font-face {
  font-family: "UTMMabella";
  src: url("../assets/font/UTM-Mabella.ttf");
}

.myDialog-enter-active,
.myDialog-leave-active {
  transition: all 0.3s;
}

.myDialog-enter,
.myDialog-leave-to {
  opacity: 0;
}

.dialog-tip {
  font-size: 18px;
  margin-top: 12px;
  color: #fffcfc;
  font-family: "Montserrat";
  font-weight: 100;
}

.form-container {
  position: relative;
  margin-top: 30px;
  .form {
    width: 520px;
    height: 590px;
    background-image: url("../assets/sport6/form/form-bg.png");
    background-size: 100% 100%;

    .tags {
      width: 100%;
      height: 97px;
      position: relative;
      top: -35px;
      display: flex;
      align-items: center;
      justify-content: center;

      .tag {
        width: 35%;
        height: 75%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url("../assets/sport6/form/login-1.png");
        background-size: 100% 100%;
        cursor: pointer;
        position: relative;

        &.register {
          background-image: url("../assets/sport6/form/register-1.png");
        }

        &.active {
          height: 90%;
          width: 70%;
          background-image: url("../assets/sport6/form/login-2.png");
          &.register {
            background-image: url("../assets/sport6/form/register-2.png");
          }
        }
      }
    }

    .inputs {
      height: 88%;
      position: relative;
      top: -30px;
      .bottom-tips {
        font-size: 18px;
        line-height: 40px;
        font-weight: 400;
        color: #000000;
        //display: none;
      }
    }
    .loginInputs{
      top: 0;
    }

    .form-input {
      width: 70%;
      height: 47px;
      position: relative;
      margin: 0 auto 35px;

      .errMsg {
        background: linear-gradient(135.48deg, #990000 0%, #F90707 89.26%);
        -webkit-background-clip: text;
        color: transparent;
        font-size: 18px;
        line-height: 30px;
        font-weight: 400;

        &.longErrMsg {
          left: 50%;
          width: 100%;
          transform: translateX(-50%);
        }
      }
      img {
        width: 20px;
        height: 20px;
        position: absolute;
        top: calc(50% - 10px);
        left: 20px;
      }

      input {
        width: 100%;
        height: 100%;
        background: transparent url("../assets/sport5/bgi-input.png") no-repeat;
        background-size: 100% 100%;
        border: none;
        outline: none;
        text-indent: 58px;
        font-size: 24px;
        color: #ffffff;
        &::placeholder {
          color: #fbfde8;
          opacity: 0.9;
          font-size: 20px;
          // 这里让浏览器自动去判断
          line-height: normal;
        }
      }

      .codeArea{
        height: 47px;
        display: flex;
        align-items: center;
        column-gap: 7px;
        .code {
          height: 100%;
          width: 50%;
          .codeImg{
            cursor: pointer;
            position: relative;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            border-radius: 10px;
          }
        }
      }
    }

    .submitArea {
      text-align: center;
      .btn{
        cursor: pointer;
        width: 60%;
        margin-top: 35px;
      }
    }
    .login{
      margin-top: 30px;
    }

    a.error {
      color: #000;
      font-size: 18px;
      line-height: 40px;
      font-weight: 400;
      text-decoration: underline;
      text-align: center;
      position: absolute;
      right: 0;
    }
    .submitBtn {
      margin-top: 20px;
      width: 180px;
      cursor: pointer;
      &.reg {
        height: 55px;
      }

      &.login {
        margin: 20px auto;
        height: 55px;
        bottom: 42px;
      }
    }
  }
}
.app-form-container {
  position: relative;
  text-align: center;
  margin-top: 0.3rem;

}
</style>



// WEBPACK FOOTER //
// src/components/Sport6.vue